module.exports = __webpack_public_path__ + "static/img/map_hebei.535d1ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_hebei.png
// module id = 2a4N
// module chunks = 0